import { useEffect } from 'react';

/** Keep separate customer/employee sessions current without interrupting local drafts. */
export function useSetupRefresh(refresh: () => Promise<void>) {
  useEffect(() => {
    let pending = false;
    const update = async () => {
      if (document.visibilityState === 'hidden' || pending) return;
      pending = true;
      try {
        await refresh();
      } finally {
        pending = false;
      }
    };
    const onVisible = () => { void update(); };
    const interval = window.setInterval(onVisible, 10000);
    window.addEventListener('focus', onVisible);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('focus', onVisible);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [refresh]);
}
